import { useEffect } from "react";

/**
 * Storefront page — renders the "Dragonborn Storefront" artifact HTML
 * verbatim. The artifact is a self-contained document (its own CSS,
 * fonts, and JS), served as a static asset from /store.html. We embed
 * it via a full-viewport iframe so its styles and scripts never
 * collide with the outer React app (Tailwind, shadcn primitives, etc.)
 * and it renders byte-identical to the original file.
 *
 * Route: "/"  (see App.js). Reachable directly at /store.html as well.
 */
export default function Storefront() {
  useEffect(() => {
    // Prevent the outer app's html/body scrollbars from double-scrolling
    // against the iframe's own scroll while this page is mounted.
    const prev = {
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyMargin: document.body.style.margin,
      bodyBg: document.body.style.background,
    };
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.body.style.margin = "0";
    // Match the artifact's background so any brief flash before the
    // iframe paints looks intentional rather than white.
    document.body.style.background = "#100d0a";
    return () => {
      document.documentElement.style.overflow = prev.htmlOverflow;
      document.body.style.overflow = prev.bodyOverflow;
      document.body.style.margin = prev.bodyMargin;
      document.body.style.background = prev.bodyBg;
    };
  }, []);

  return (
    <iframe
      title="Dragonborn Storefront"
      src="/store.html"
      data-testid="storefront-iframe"
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        margin: 0,
        padding: 0,
        display: "block",
        background: "#100d0a",
      }}
    />
  );
}
